<template>
  <div class="yandex-maps-page">
    <yandex-map
      :coords="coords"
      :zoom="10"
      :controls="['zoomControl', 'geolocationControl','fullscreenControl']"
      @click="onClick"
      style="width: 100%; height: 400px;"
    >
      <ymap-marker
        :coords="coords"
        marker-id="ymap-markey-id"
      />
    </yandex-map>

  </div>
</template>

<script>

import { yandexMap } from 'vue-yandex-maps'

export default {
  name: 'yandex-maps-page',
  components: {
    yandexMap,
  },
  data () {
    return {
      coords: [54.9914, 73.3645],
      full_address: null,
    }
  },
  mounted () {
    this.currLoc()
  },
  methods: {
    onClick (e) {
      this.coords = e.get('coords')
      const myGeocoder = window.ymaps.geocode(this.coords)
      myGeocoder.then((res) => {
        this.full_address = res.geoObjects.get(0).properties.getAll().text
      })
      const data = {
        coords: this.coords,
        full_address: this.full_address,
      }
      this.$emit('coords', data)
    },
    currLoc () {
      const myGeocoder = window.ymaps.geocode([54.9914, 73.3645])
      myGeocoder.then((res) => {
        this.full_address = res.geoObjects.get(0).properties.getAll().text
      })
    },
  },
}
</script>
